export default "__VITE_ASSET__7c6ffe7f__"